import { ConfirmInputDataModel } from './model/confirm-input-data.model';
import { SelectModel } from '@/core/domain/models/components/inputs/select.model';
import { MessagesUtils } from '@/core/utils/layout/messages.utils';
import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-input-data',
  templateUrl: './confirm-input-data.component.html',
  styleUrl: './confirm-input-data.component.scss',
  standalone: false,
})
export class ConfirmInputDataComponent implements OnInit {
  private messagesUtils = inject(MessagesUtils);
  private modalRef = inject(DynamicDialogRef);
  private modalConfig = inject(DynamicDialogConfig);

  model: ConfirmInputDataModel = new ConfirmInputDataModel();
  isModalOpened = false;

  ngOnInit(): void {
    if (this.modalConfig.data) {
      this.model = this.modalConfig.data;
    }
  }

  get maskInput(): string {
    return this.model?.maskInput;
  }

  get options(): Array<SelectModel> {
    return this.model?.options ?? [];
  }

  async confirm() {
    if (!this.isValid()) {
      this.messagesUtils.showMessageError(
        "messages.error.requiredInputFieldsIsNull"
      );
      return;
    }
    this.close(this.model.value);
  }

  close(value?: any) {
    this.modalRef.close(value);
  }

  isValid() {
    return !!this.model?.value;
  }

  selectAllTextWithDelay(event: any, delay: number) {
    setTimeout(() => {
      event?.target?.select();
    }, delay);
  }
}
